import { Badge } from "@/components/ui/badge";
import { embeddingStatusClasses, embeddingStatusLabel } from "@/lib/enrichment";
import { cn } from "@/lib/utils";

/**
 * Colored badge for an entity's `embeddingStatus` — the sibling of
 * {@link "@/components/common/enrichment-status-badge".EnrichmentStatusBadge}.
 *
 * Artist, venue, genre and event are all embeddable and Tina writes the status
 * for all four, but only `/events` used to render it, with its own inline
 * colour map. Renders nothing for an empty status; a status the backend
 * grows after this deploy keeps a neutral treatment instead of an unstyled
 * badge, which is what indexing the colour map unguarded produced.
 */
export function EmbeddingStatusBadge({
  status,
  className,
}: {
  status?: string | null;
  className?: string;
}) {
  if (!status) return null;
  return (
    <Badge
      variant="outline"
      className={cn(embeddingStatusClasses(status), className)}
    >
      {embeddingStatusLabel(status)}
    </Badge>
  );
}
